import axios from 'axios'

import {
  API_URL
} from "@/globalVariables";

export const pipedriveApi = {
  async getCustomFields(token) {
    try {
      const response = await axios.get('https://api.pipedrive.com/v1/dealFields', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      return response.data.data
    } catch (error) {
      console.error('Erro ao buscar custom fields:', error)
      throw error
    }
  },

  async getDealCustomField(dealId, token) {
    try {
      const response = await axios.get(`https://api.pipedrive.com/v1/deals/${dealId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      return response.data.data
    } catch (error) {
      console.error('Erro ao buscar deal:', error)
      throw error
    }
  },

  async getRealEstateOrderSummary() {
    try {
      //const response = await axios.get(`https://joaoboot.franquezatech.com/get-deal-result/322650`)

      const response = await axios.get(`${API_URL}/real-estate/summary/5126537b-2455-4ad0-9dc0-bee19469505b/`, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar resumo da order:', error)
      throw error
    }
  }
}